module.exports = __webpack_public_path__ + "img/hr-H-B-3-load-standup-shadow.b151d41d.png";